export enum PoiElementType {
    NODE = "node",
    RELATION = "relation",
    WAY = "way"
}

export enum PoiType {
    TRANSPORT = "transport",
    HEALTH = "health",
    EDUCATION = "education",
    FOOD = "food",
    SHOPS = "shops",
    SPORT = "sport",
    ENTERTAINMENT = "entertainment",
    ALL = "all",
    OFFERS = "offers",
    USER = "user"
}

export enum TransportPoiType {
    BUS = "bus",
    TRAM = "tram",
    SUBWAY = "subway",
    RAILWAY = "railway"
}
export enum PoiElementType {
    NODE = "node",
    RELATION = "relation",
    WAY = "way"
}

export enum PoiType {
    TRANSPORT = "transport",
    HEALTH = "health",
    EDUCATION = "education",
    FOOD = "food",
    SHOPS = "shops",
    SPORT = "sport",
    ENTERTAINMENT = "entertainment",
    ALL = "all",
    OFFERS = "offers",
    USER = "user"
}

export enum TransportPoiType {
    BUS = "bus",
    TRAM = "tram",
    SUBWAY = "subway",
    RAILWAY = "railway"
}
